module.exports = __webpack_public_path__ + "static/media/wifi.fc11fd74.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wifi.png
// module id = 411
// module chunks = 0